/**
 * Parcours en vidéo : pour certains modules, une suite d'extraits d'écran enregistrés dans l'application, qui s'enchaînent
 * dans l'ordre où l'on s'en sert. Chaque extrait a son titre et ses points ; les captures fixes du module servent de repli
 * (appareil qui demande moins d'animation, vidéo non lisible).
 */
export interface ChapitreVideo { src: string; titre: string; points: string[] }

export const PARCOURS_VIDEOS: Record<string, Record<string, ChapitreVideo[]>> = {
    restaurateur: {
        'Livre de réservations': [
            {
                src: '/vitrine/videos/widget-reservation.webm',
                titre: 'Le client réserve en ligne, en quelques touches.',
                points: [
                    'Nombre de personnes, jour, puis heure : uniquement les créneaux réellement disponibles.',
                    "Ses coordonnées, ses allergies et l'occasion arrivent dans la fiche de la réservation.",
                    'La demande part au restaurant, qui la confirme d’un clic.',
                ],
            },
            {
                src: '/vitrine/videos/retard-client.webm',
                titre: 'Le client prévient d’un retard, vous le voyez dans le livre.',
                points: [
                    'Depuis le lien de son e-mail, il touche 15, 30 ou 45 minutes, dans les 2 heures qui précèdent la réservation.',
                    'Dans votre livre, « Prévenu : +30 min » apparaît à côté de l’heure.',
                    'Vous gardez la table sans avoir à rappeler.',
                ],
            },
            {
                src: '/vitrine/videos/complet-tailles.webm',
                titre: 'Presque complet : fermez les tables de 3 et plus, gardez celles de 2.',
                points: [
                    'Un clic sur ⦸ à côté du service, puis « Un nombre de couverts ».',
                    'Vous cochez les tailles de table que vous ne pouvez plus accueillir : pour tout le service, à partir d’une heure, ou sur certains créneaux.',
                    'Sur la page de réservation, ces tailles passent en « fermé » tout de suite.',
                ],
            },
        ],
        'Planning et feuille de route': [
            {
                src: '/vitrine/videos/planning-reglages.webm',
                titre: 'Réglez vos horaires une fois : le planning se remplit tout seul.',
                points: [
                    'Des horaires types (midi, soir ou les deux), puis l’horaire par défaut de chaque salarié, jour par jour.',
                    'Des codes d’absence : « Journée » remplace la journée, « Auto » se répète sur midi et soir ; sans les deux, le code ne touche qu’un service.',
                    'Un clic sur la case d’un salarié pour poser un code sur le service de midi seulement.',
                ],
            },
            {
                src: '/vitrine/videos/planning-feuille-de-route.webm',
                titre: 'Modifiez un horaire, imprimez, placez vos salariés dans leurs rangs.',
                points: [
                    'Un clic sur le créneau d’un salarié pour changer son horaire.',
                    'Le PDF du planning de la semaine, ou la feuille de présence du jour, prête à signer.',
                    'La feuille de route : chaque salarié dans son rang, avec l’aperçu du planning à droite.',
                ],
            },
        ],
    },
};
